import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getAllSsqVersionAssignmentsKey } from "src/api/client-api/questionnaire/useGetAllSsqVersionAssignments";

type UpdateSsqVersionAssignmentPayload = {
    id: number;
    ssqVersionId: number;
};

export const useUpdateSsqVersionAssignment = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ id, ...payload }: UpdateSsqVersionAssignmentPayload) => {
            const response = await loggedInApiCall.put(`/api/ssq-version-assignments/${id}`, payload);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(getAllSsqVersionAssignmentsKey);
        },
    });
};
